import { useAuth } from "react-oidc-context";

const IsAuthLoading = ({ children }) => {
  const { isLoading, activeNavigator } = useAuth();

  // activeNavigator === "signOutRedirect" on logout
  if (isLoading || activeNavigator) {
    return children;
  }

  return null;
};

export default IsAuthLoading;
